// extracted by mini-css-extract-plugin
module.exports = {"tickList":"RegistrationBenefits_tickList__WcJeG","heading":"RegistrationBenefits_heading__w1B3f"};